import { ResumeData } from '../types';
import { HeaderSection } from './sections/HeaderSection';
import { SummarySection } from './sections/SummarySection';
import { ExperienceSection } from './sections/ExperienceSection';
import { EducationSection } from './sections/EducationSection';
import { SkillsSection } from './sections/SkillsSection';
import { CoursesSection } from './sections/CoursesSection';
import { LanguagesSection } from './sections/LanguagesSection';
import { AwardsSection } from './sections/AwardsSection';
import { AdditionalSectionsSection } from './sections/AdditionalSectionsSection';
import { ProjectsSection } from './sections/ProjectsSection';
import { SettingsSection } from './sections/SettingsSection';

interface ResumeFormProps {
    data: ResumeData;
    onChange: (data: Partial<ResumeData>) => void;
    onOptimizeSummary: (summary: string) => void;
    onOptimizeBullet: (jobIndex: number, bulletIndex: number, bulletText: string) => void;
    optimizingSummary?: boolean;
    optimizingBulletKey?: string | null;
}

export function ResumeForm({
    data,
    onChange,
    onOptimizeSummary,
    onOptimizeBullet,
    optimizingSummary = false,
    optimizingBulletKey = null,
}: ResumeFormProps) {
    const safeSkills = data.skills || { categories: [] };
    return (
        <div className="space-y-6">
            <HeaderSection
                header={data.header}
                onChange={(header) => onChange({ header })}
            />

            <SummarySection
                summary={data.summary}
                onChange={(summary) => onChange({ summary })}
                onOptimize={onOptimizeSummary}
                isOptimizing={optimizingSummary}
            />

            <ExperienceSection
                experience={data.experience}
                onChange={(experience) => onChange({ experience })}
                maxBulletLength={data.settings?.maxBulletLength}
                onOptimizeBullet={onOptimizeBullet}
                optimizingBulletKey={optimizingBulletKey}
            />

            <EducationSection
                education={data.education}
                onChange={(education) => onChange({ education })}
            />

            <SkillsSection
                skills={safeSkills}
                onChange={(skills) => onChange({ skills })}
            />

            <CoursesSection
                courses={data.courses || []}
                onChange={(courses) => onChange({ courses })}
            />

            <LanguagesSection
                languages={data.languages || []}
                onChange={(languages) => onChange({ languages })}
            />

            <AwardsSection
                awards={data.awards || []}
                onChange={(awards) => onChange({ awards })}
            />

            <ProjectsSection
                projects={data.projects || []}
                onChange={(projects) => onChange({ projects })}
            />

            <SettingsSection
                settings={data.settings}
                onChange={(settings) => onChange({ settings })}
            />

            <AdditionalSectionsSection
                customSections={data.customSections || []}
                onChange={(customSections) => onChange({ customSections })}
            />
        </div>
    );
}
